module.exports = __webpack_public_path__ + "static/Ronald-Rochon-Signature-e5aeab1defac62db60f986158a55683e.svg";